<app-step-progress [steps]="steps"></app-step-progress>
<app-page-title [title]="'Biometric Consent'"></app-page-title>
<app-proof-of-identity-selection-summary [testSession]="testSession$ | async"></app-proof-of-identity-selection-summary>
<app-biometric-consent-form
    [isRegFlow]="true"
    (setBiometricConsent)="goNext($event)"
></app-biometric-consent-form>
